module.exports = __webpack_public_path__ + "static/media/bus-camp-camper-svgrepo-com.fefca88e.svg";